// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NativeSelect_wrapper__3wn7x","select":"NativeSelect_select__2QXB9","placeholder":"NativeSelect_placeholder__3FcY7","icon":"NativeSelect_icon__3lgDG"};